import clsx from "clsx";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useShallow } from "zustand/shallow";
import buy from "@/assets/images/buy.svg";
import hammer from "@/assets/images/hammer.svg";
import { useSignIn } from "@/hooks/useSignIn";
import { useAuth } from "@/stores/useAuth";
import { useFreeChest } from "../countdown/data";
import Spinner from "../spinner";
import { useChestNumber } from "./data";
import { useOpenChestStore } from "@/stores/use-open-chest";

export function Chest() {
  const [address, walletLoading] = useAuth(
    useShallow((state) => [state.address, state.isLoading])
  );
  const { signIn } = useSignIn();
  const navigate = useNavigate();
  const [isLoadingSmash] = useOpenChestStore(
    useShallow((state) => [state.isLoading])
  );

  const { data, isLoading } = useChestNumber(address);
  const { isLoading: isLoadingSmashed, data: dataFreeChest } = useFreeChest();

  const number_of_eggs = useMemo(() => {
    const value = dataFreeChest?.isOpenFreeChest ? 0 : 1;

    return !data ? "0" : String(data.data.unusedPaymentCount + value);
  }, [data, dataFreeChest?.isOpenFreeChest]);

  const loading = isLoading || walletLoading || isLoadingSmashed;

  const handleBuyChest = useCallback(async () => {
    if (!address) {
      const info = await signIn();
      if (info?.address) {
        navigate("./buy-chest");
      }
    } else {
      navigate("./buy-chest");
    }
  }, [address, signIn, navigate]);

  return (
    <div className="flex items-center justify-between gap-1 h-7">
      <Numbers number_of_eggs={number_of_eggs} isLoading={loading} />
      <button
        type="button"
        disabled={isLoadingSmash}
        onClick={() => {
          handleBuyChest();
        }}
        className={clsx("relative", {
          hidden: loading,
        })}
      >
        <img src={hammer} alt="hammer" className="absolute -top-2 -left-2" />
        <img
          src={buy}
          alt="buy"
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </button>
    </div>
  );
}

function Numbers({
  isLoading,
  number_of_eggs,
}: {
  isLoading: boolean;
  number_of_eggs: string;
}) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-1">
      <p className="text-base text-white">{t("smashes")}</p>

      {isLoading ? (
        <Spinner className="w-4 h-4" />
      ) : (
        <div
          className={clsx(
            "bg-white rounded-tl-md rounded-br-md font-medium",
            "h-5 flex items-center justify-center px-1"
          )}
        >
          <p className="text-[16px] leading-4 text-black">x{number_of_eggs}</p>
        </div>
      )}
    </div>
  );
}
